import AnimationClip from '../AnimationClip';
import Rope from 'Prototype/Rope';
import RopeComponent from 'Component/Render/Rope';
import { Easing } from '@tweenjs/tween.js';
import Renderable from '../../../Component/Renderable';
import Point from '../../../Utility/Point';
import { AwaitIterators } from '../AnimationHelper';

interface IMeta {
}

export class RopeAppearing extends AnimationClip<IMeta> {
    public* execute(
        rope: Rope,
        meta: IMeta,
    ): IterableIterator<number> {
        const ropeComponent = rope.getComponent(RopeComponent);
        const ropeRenderable = rope.getComponent(Renderable);
        const mx = (ropeComponent.startNode.x + ropeComponent.endNode.x) / 2;
        const my = (ropeComponent.startNode.y + ropeComponent.endNode.y) / 2 - 100;
        const startNodePoint = new Point(mx, my);
        const endNodePoint = new Point(mx, my);

        const onUpdate = () => {
            ropeComponent.setEdgePoints(startNodePoint, endNodePoint);
        };

        const startNodeTween = this
            .getTween(startNodePoint)
            .to({
                x: ropeComponent.startNode.x,
                y: ropeComponent.startNode.y,
            }, 800)
            .easing(Easing.Back.Out)
            .onUpdate(onUpdate);

        const endNodeTween = this
            .getTween(endNodePoint)
            .to({
                x: ropeComponent.endNode.x,
                y: ropeComponent.endNode.y,
            }, 800)
            .easing(Easing.Back.Out);

        ropeRenderable.alpha = 0;

        const alphaTween = this
            .getTween(ropeRenderable)
            .to({ alpha: 1 }, 200)
            .delay(100);

        yield* AwaitIterators([
            this.startTween(startNodeTween),
            this.startTween(endNodeTween),
            this.startTween(alphaTween),
        ]);
    }
}
